import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useEffect, useRef } from 'react'
import { Link, useNavigate, useSearchParams } from 'react-router-dom'
import { api, json } from '../api/client'
import type { SignedIn } from '../api/types'
import { ErrorNote, LoadingBlock } from '../components/ui'
import { meKey } from '../hooks/useMe'

/**
 * The emailed link lands here. Spending the token takes a JavaScript POST, so
 * mail scanners that prefetch links cannot use it up.
 */
export function MagicLinkPage() {
  const [params] = useSearchParams()
  const token = params.get('token')
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const verify = useMutation({
    mutationFn: (value: string) => api<SignedIn>('/auth/magic/verify', { method: 'POST', body: json({ token: value }) }),
    onSuccess: async ({ return_to }) => {
      await queryClient.invalidateQueries({ queryKey: meKey })
      navigate(return_to, { replace: true })
    },
  })
  const started = useRef(false)
  const { mutate } = verify
  useEffect(() => {
    if (token && !started.current) {
      started.current = true
      mutate(token)
    }
  }, [token, mutate])

  return (
    <div className="auth-page">
      <div className="auth-card card">
        <div className="card-body stack">
          {!token && <ErrorNote message="This link is missing its token." />}
          {verify.isError && <ErrorNote error={verify.error} />}
          {(!token || verify.isError) && <Link to="/login">Request a new link</Link>}
          {token && !verify.isError && <LoadingBlock label="Signing you in…" />}
        </div>
      </div>
    </div>
  )
}
